import { useSelector } from "react-redux";
import schema from "../languages.json";
import { useMemo } from "react";

export const useLanguageSchema = (route) => {
  const language = useSelector((state) => state.app.language) || "en";
  const currentSchema = useMemo(() => schema[language], [language]);
  if (!route) return currentSchema;

  const routeSchema = route.split(".").reduce((acc, key) => {
    if (!acc[key]) return acc;
    return acc[key];
  }, currentSchema);

  if (routeSchema) return routeSchema;

  return currentSchema;
};
